export const BREAKPOINT_XS = 480
export const BREAKPOINT_S = 768
export const BREAKPOINT_M = 1024
export const BREAKPOINT_L = 1200
export const BREAKPOINT_XL = 1440
export const SCREEN_XS = `min-width: ${BREAKPOINT_XS}px`
export const SCREEN_S = `min-width: ${BREAKPOINT_S}px`
export const SCREEN_M = `min-width: ${BREAKPOINT_M}px`
export const SCREEN_L = `min-width: ${BREAKPOINT_L}px`
export const SCREEN_XL = `min-width: ${BREAKPOINT_XL}px`
